export default __webpack_public_path__ + "static/media/Time.5093c5dc.svg";